import { isHotkeyToOpenWidget } from '@uw/common-components';
import { useCallback, useEffect } from 'preact/hooks';
import { useApplicationSetup } from 'contexts/use-application-setup';
import { copyTextToClipboard } from '@uw/utils';
import { stateStore } from '../global/state.store';
import { Trigger } from '../types/trigger';

export const useKeyboardEvents = (config: ReturnType<typeof useApplicationSetup>) => {
  const keyDown = useCallback(
    (event) => {
      if (event.keyCode === 76 && event.ctrlKey) {
        // CTRL + L
        event.preventDefault();
        if (config.trigger === Trigger.Main) {
          stateStore.state.next('main.login');
        }
      }

      if (isHotkeyToOpenWidget(config, event) || event.keyCode === 27) {
        // check if tooltip in widget is focused
        const activeElement = document.activeElement as HTMLButtonElement;
        const isTooltipFocused = activeElement?.classList?.contains('uwaw-main-tooltip-icon');
        if (isTooltipFocused && event.keyCode === 27) {
          // hide tooltip on first Esc key press
          activeElement.blur();
        } else {
          // CTRL + U - default; or Escape
          event.preventDefault();
          config.close();
        }
      }

      if (event.keyCode === 75 && event.ctrlKey) {
        // CTRL + K
        event.preventDefault();
        const configCode = config.code;
        copyTextToClipboard(configCode);
      }

      if (event.keyCode === 74 && event.ctrlKey) {
        // CTRL + J
        event.preventDefault();
        const configUserId = config.config.current.services.userId;
        configUserId && copyTextToClipboard(configUserId);
      }
    },
    [config],
  );

  useEffect(() => {
    if (config.isOpen) {
      window.addEventListener('keydown', keyDown);
    }

    return () => {
      window.removeEventListener('keydown', keyDown);
    };
  }, [keyDown, config?.isOpen]);
};
